import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Config } from 'datatables.net';
import { Subject } from 'rxjs';
import { Partner } from '../../models/partner';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { ModalService } from '../../services/modal/modal.service';
import { PartnerService } from '../../services/partner.service';

@Component({
  selector: 'app-partners',
  imports: [DataTablesModule, CommonModule, RouterModule],
  templateUrl: './partners.component.html',
  styleUrl: './partners.component.scss',
})
export class PartnersComponent implements OnInit, AfterViewInit {
  dtOptions!: Config;

  partners!: any[];

  fullyLoaded: boolean = false;

  @ViewChild(DataTableDirective)
  datatableElement!: DataTableDirective;
  dtTrigger: Subject<any> = new Subject<any>();

  constructor(
    private partnerService: PartnerService,
    private authService: AuthenticationService,
    private modalService: ModalService,
    private vcr: ViewContainerRef,
    private router: Router,
    private destroyRef: DestroyRef,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.partnerService.getPartners().subscribe({
      next: (response) => {
        this.partners = response;
        this.fullyLoaded = true;
        this.changeDetector.detectChanges();
        this.dtTrigger.next(null);
      },
      error: (err: HttpErrorResponse) => this.authService.logout(),
    });

    this.dtOptions = {
      pagingType: 'full_numbers',
      destroy: true,
      search: {
        caseInsensitive: true,
        smart: true,
      },
      ajax: (dataTablesParameters: any, callback) => {
        callback({ data: this.partners });
      },
      lengthMenu: [5, 10, 20, 50],
      columns: [
        {
          title: 'Name',
          data: 'name',
        },
        {
          title: 'Address',
          data: 'address',
        },
        {
          title: 'City',
          data: 'city',
        },
        {
          title: 'Phone',
          data: 'phone',
        },
        {
          title: 'Email',
          data: 'email',
        },
        {
          title: 'PIB',
          data: 'pib',
        },
        {
          title: 'Status',
          data: 'active',
          render: (data, type, row, meta) => {
            return data == 1
              ? '<td><i class="mdi mdi-circle text-success"></i> Active</td>'
              : ' <td><i class="mdi mdi-circle text-danger"></i> Inactive</td>';
          },
        },
        {
          title: 'Action',
          data: null,
          orderable: false,
          render: (data, type, row, meta) => {
            return `<a href="javascript: void(0);" id="edit" class="action-icon"> <i class="mdi mdi-pencil"></i></a><a href="javascript: void(0);" id="delete" class="action-icon"> <i class="mdi mdi-delete"></i></a>`;
          },
        },
      ],
      rowCallback: (row: Node, data: any[] | object, index: number) => {
        $('td:last-child #delete', row).off('click');
        $('td:last-child #edit', row).off('click');
        $('td:last-child #delete', row).on('click', () =>
          this.deletePartner((data as Partner).id)
        );
        $('td:last-child #edit', row).on('click', () =>
          this.editPartner(data as Partner)
        );
      },
    };
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  deletePartner(id: number) {
    this.modalService
      .openYesNoDialog(this.vcr)
      .getAnswer()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (answer) => {
          if (answer) {
            this.partnerService
              .deletePartner(id)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe({
                next: () => {
                  this.partners = this.partners.filter(
                    (p: Partner) => p.id !== id
                  );
                  this.dtTrigger.next(null);
                },
                error: (err: HttpErrorResponse) => {
                  if (err.status == 401) {
                    this.authService.logout();
                  } else {
                    this.modalService.showErrorDialog(
                      this.vcr,
                      err.error.message
                    );
                  }
                },
              });
          }
        },
      });
  }

  editPartner(partner: Partner) {
    localStorage.setItem('edit', JSON.stringify(partner));
    this.router.navigateByUrl('dashboard/partners/update');
  }
}
